import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "./Contact.css";

const Contact = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = {
      name,
      email,
      message,
    };

    try {
      const response = await fetch(
        "https://sudhamshu-ayurveda-git-preview-vaishavikm-sudhamshus-projects.vercel.app/submit",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      const result = await response.text();

      if (response.ok) {
        alert("Message sent successfully!");
        setName("");
        setEmail("");
        setMessage("");
      } else {
        alert(`Failed to send message: ${result}`);
      }
    } catch (error) {
      alert(`Something went wrong: ${error.message}`);
    }
  };

  return (
    <>
      <Navbar />

      {/* =================================
          CONTACT HERO
      ================================= */}
      <section className="contact-hero">
        <div className="contact-hero-overlay"></div>

        <div className="contact-hero-content">
          <span className="contact-eyebrow">GET IN TOUCH</span>

          <h1>Let’s Begin Your Wellness Journey</h1>

          <div className="contact-hero-divider"></div>

          <p>
            Connect with Sudhamshu Ayurveda for personalized Ayurvedic
            consultation and care.
          </p>
        </div>
      </section>

      {/* =================================
          QUICK CONTACT ACTIONS
      ================================= */}
      <section className="contact-actions-section">
        <div className="contact-actions">

          <a
            href="tel:+917406680614"
            className="contact-action-card"
          >
            <div className="contact-action-icon">
              <i className="fas fa-phone"></i>
            </div>

            <div>
              <span>CALL THE CLINIC</span>
              <strong>+91 74066 80614</strong>
            </div>
          </a>

          <a
            href="mailto:sudhamshu.ayurveda@gmail.com"
            className="contact-action-card"
          >
            <div className="contact-action-icon">
              <i className="fas fa-envelope"></i>
            </div>

            <div>
              <span>EMAIL US</span>
              <strong>sudhamshu.ayurveda@gmail.com</strong>
            </div>
          </a>

          <a
            href="https://www.google.com/maps/search/?api=1&query=Sudhamshu+Ayurveda+Bengaluru"
            target="_blank"
            rel="noopener noreferrer"
            className="contact-action-card"
          >
            <div className="contact-action-icon">
              <i className="fas fa-location-dot"></i>
            </div>

            <div>
              <span>VISIT THE CLINIC</span>
              <strong>Banashankari, Bengaluru</strong>
            </div>
          </a>

        </div>
      </section>

      {/* =================================
          MAIN CONTACT SECTION
      ================================= */}
      <section className="contact-main-section">

        <div className="contact-main-container">

          {/* CONTACT INFORMATION */}
          <div className="clinic-information">

            <span className="section-eyebrow">
              VISIT SUDHAMSHU AYURVEDA
            </span>

            <h2>We’re Here to Help You</h2>

            <p className="clinic-intro">
              Whether you are looking for an Ayurvedic consultation,
              personalized care, or simply have a question, we are happy to
              hear from you.
            </p>

            <div className="clinic-detail-list">

              <div className="clinic-detail">
                <div className="detail-icon">
                  <i className="fas fa-location-dot"></i>
                </div>

                <div>
                  <h3>Clinic Address</h3>

                  <p>
                    Sudhamshu Ayurveda,
                    <br />
                    #36, 9th Cross Bhuvaneshwari Nagar,
                    <br />
                    Abbaiyya Naidu Studio Road,
                    <br />
                    Banashankari 3rd Stage,
                    <br />
                    Bengaluru - 560085, India
                  </p>
                </div>
              </div>

              <div className="clinic-detail">
                <div className="detail-icon">
                  <i className="fas fa-phone"></i>
                </div>

                <div>
                  <h3>Phone</h3>

                  <a href="tel:+917406680614">
                    +91 74066 80614
                  </a>
                </div>
              </div>

              <div className="clinic-detail">
                <div className="detail-icon">
                  <i className="fas fa-envelope"></i>
                </div>

                <div>
                  <h3>Email</h3>

                  <a href="mailto:sudhamshu.ayurveda@gmail.com">
                    sudhamshu.ayurveda@gmail.com
                  </a>
                </div>
              </div>

            </div>

            {/* CONSULTATION HOURS */}
            <div className="consultation-hours">

              <h3>Consultation Hours</h3>

              <div className="hours-row">
                <span>Online Consultation</span>
                <strong>
                  10:30 AM – 1:00 PM
                  <br />
                  5:00 PM – 7:30 PM
                </strong>
              </div>

              <div className="hours-row">
                <span>In-Clinic Consultation</span>
                <strong>
                  10:30 AM – 2:00 PM
                </strong>
              </div>

              <div className="weekend-note">
                <i className="fas fa-calendar-check"></i>

                <span>
                  Weekends are available on prior appointments only.
                </span>
              </div>

            </div>

          </div>

          {/* CONTACT FORM */}
          <div className="contact-form-card">

            <div className="form-heading">
              <span className="section-eyebrow">
                SEND AN ENQUIRY
              </span>

              <h2>How Can We Help?</h2>

              <p>
                Share your details and your enquiry. Our team will get back
                to you.
              </p>
            </div>

            <form onSubmit={handleSubmit}>

              <div className="form-field">
                <label htmlFor="name">
                  Full Name
                </label>

                <input
                  type="text"
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  placeholder="Your name"
                  required
                />
              </div>

              <div className="form-field">
                <label htmlFor="email">
                  Email Address
                </label>

                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  required
                />
              </div>

              <div className="form-field">
                <label htmlFor="message">
                  Your Message
                </label>

                <textarea
                  id="message"
                  rows="6"
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Tell us how we can help..."
                  required
                ></textarea>
              </div>

              <button
                type="submit"
                className="contact-submit-button"
              >
                Send Enquiry
                <i className="fas fa-arrow-right"></i>
              </button>

            </form>
          </div>

        </div>
      </section>

      {/* =================================
          MAP
      ================================= */}
      <section className="location-section">

        <div className="location-heading">
          <span className="section-eyebrow">
            FIND US
          </span>

          <h2>Visit Our Clinic</h2>

          <p>
            Located in Banashankari 3rd Stage, Bengaluru.
          </p>
        </div>

        <div className="map-container">

          <iframe
            title="Sudhamshu Ayurveda Clinic Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3888.787344396874!2d77.54486967377487!3d12.921385087389378!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae3f001f598241%3A0x86507ca79ba65377!2sSudhamshu%20Ayurveda!5e0!3m2!1sen!2sin!4v1754733761025!5m2!1sen!2sin"
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>

        </div>

        <a
          href="https://www.google.com/maps/search/?api=1&query=Sudhamshu+Ayurveda+Bengaluru"
          target="_blank"
          rel="noopener noreferrer"
          className="directions-button"
        >
          Get Directions
          <i className="fas fa-arrow-right"></i>
        </a>

      </section>

      {/* =================================
          CONSULTATION JOURNEY
      ================================= */}
      <section className="contact-journey">

        <div className="journey-heading">
          <span className="section-eyebrow">
            WHAT TO EXPECT
          </span>

          <h2>Your Consultation Journey</h2>

          <p>
            A simple approach to begin your Ayurvedic wellness journey.
          </p>
        </div>

        <div className="journey-steps">

          <div className="journey-step">
            <span className="step-number">01</span>

            <h3>Get in Touch</h3>

            <p>
              Contact us through phone, email, or the enquiry form to
              discuss your requirements.
            </p>
          </div>

          <div className="journey-step">
            <span className="step-number">02</span>

            <h3>Consultation</h3>

            <p>
              Discuss your concerns, health goals, and individual needs
              during your consultation.
            </p>
          </div>

          <div className="journey-step">
            <span className="step-number">03</span>

            <h3>Personalized Care</h3>

            <p>
              Receive an Ayurvedic approach tailored to your individual
              wellness journey.
            </p>
          </div>

        </div>

      </section>

      {/* =================================
          FINAL CTA
      ================================= */}
      <section className="contact-cta">

        <div className="contact-cta-content">

          <span className="section-eyebrow">
            BEGIN YOUR JOURNEY
          </span>

          <h2>
            Take the First Step Towards Better Health
          </h2>

          <p>
            Connect with Sudhamshu Ayurveda and discover personalized
            Ayurvedic care.
          </p>

          <a
            href="tel:+917406680614"
            className="contact-cta-button"
          >
            Call for Consultation
          </a>

        </div>

      </section>

      <Footer />
    </>
  );
};

export default Contact;